import 'nprogress/nprogress.css'

import NProgress from 'nprogress'

const setupUpdateProgress = () => {
    window.axios.defaults.onDownloadProgress = e => {
        const percentage = Math.floor(e.loaded * 1.0 / e.total)

        if (percentage) {
            NProgress.set(percentage)
        } else {
            NProgress.done(true)
        }
    }
}

const setupStopProgress = () => {
    window.axios.interceptors.response.use(response => {
        NProgress.done(true)
        return response
    })
}

export function load (config = {}) {
    NProgress.configure(config)
    setupUpdateProgress()
    setupStopProgress()
}
